import carrierTypes from './carrierInformationTypes'

export const getCarrier = () => ({
  type: carrierTypes.GET_CARRIER
})

export const getCarrierSuccess = payload => ({
  type: carrierTypes.GET_CARRIER_SUCCESS,
  payload
})

export const getCarrierFailure = payload => ({
  type: carrierTypes.GET_CARRIER_FAILURE,
  payload
})

export const updateCarrier = payload => ({
  type: carrierTypes.UPDATE_CARRIER,
  payload
})

export const updateCarrierSuccess = () => ({
  type: carrierTypes.UPDATE_CARRIER_SUCCESS
})

export const updateCarrierFailure = payload => ({
  type: carrierTypes.UPDATE_CARRIER_FAILURE,
  payload
})
